import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { BsCheckAll } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';

import successIcon from '../../assets/success.svg';
import { isFleetcare, isMindy, isOms } from '../../utils';

/* eslint-disable-next-line */
export interface RecoverSucceededProps {}

export function RecoverSucceeded(props: RecoverSucceededProps) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    if (isMindy || isFleetcare || isOms) {
        return (
            <div className="w-full">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                    className="space-y-5"
                >
                    <BsCheckAll className="text-primary-400 text-5xl" />
                    <div className="border-t border-gray-800" />
                    <div>
                        <h2 className="text-2xl font-poppins font-semibold text-white mb-2">
                            {t('recover.success.title')}
                        </h2>
                        <p className="text-sm text-gray-400 font-roboto">{t('recover.success.body')}</p>
                    </div>
                    <div className="border-t border-gray-800" />
                    <button
                        type="button"
                        onClick={() => navigate('/login')}
                        className="w-full bg-primary-500 hover:bg-primary-400 text-white font-poppins font-semibold py-3 rounded-lg transition-colors"
                    >
                        {t('recover.success.cta')}
                    </button>
                </motion.div>
            </div>
        );
    }

    return (
        <div className="bg-white xs:w-1/2 xs:shadow-xl shadow-slate-500/50 px-14 py-10 rounded-md font-['Roboto'] flex flex-col justify-center items-start max-w-[480px]">
            <img className="self-center mb-3" src={successIcon} alt="success-icon" />
            <h3 className="text-3xl font-bold mb-3">{t('recover.success.title')}</h3>
            <p className="text-base w-full mb-3">{t('recover.success.body')}</p>
            <button
                className="w-full h-[50px] bg-blue-800 disabled:bg-blue-200 rounded-md text-white font-['Poppins']"
                type="button"
                color="blue"
                onClick={() => navigate('/login')}
            >
                {t('recover.success.cta')}
            </button>
        </div>
    );
}

export default RecoverSucceeded;
